module.exports = __webpack_public_path__ + "img/certrosalda.fc7dc0af.png";